<template>
	<div style="height: 100%;"> 
	  	<div class="headerCom"> 
			<publicBreadCrumb  :breadList="breadList"/> 
    	</div>
		<div class="bottom-cont-box">
			<div class="left-box" v-if="!fold">
				<div class="position_btn" @click="fold=true">《收起面板</div>
				<h4>基础信息</h4>
				<el-form :disabled="!isEdit" :model="form" ref="ruleForm" size="small">
					<el-form-item label="逻辑名称:" prop="name" label-width="100px" size="medium">
						{{form.name}}
					</el-form-item>
					<el-form-item label="主适配病种:" prop="diseaseId" label-width="100px">
						{{form.diseaseName}}
					</el-form-item>
					<el-form-item label="适配病种:" props="subDiseaseIds" label-width="100px">
						{{form.subDiseaseNames}}
					</el-form-item>
					<el-form-item label="分类:" prop="typeId" label-width="100px">
						{{form.typeNames}}
					</el-form-item>
					<el-form-item label="描述:" class="wordBreak" prop="description" label-width="100px">
						{{form.description}}
					</el-form-item>
				</el-form>
				
			</div>
			<div class="right-box">
				<div class="position_btn" v-if="fold" @click="fold=false">展开面板》</div>
				<div class="right-btn" v-if="!noShow && pageName=='patientPage'">
					<el-button style="width: 110px;" type="primary" size="small" @click="goMain">编辑</el-button>
				</div>
				<div class="right-btn" v-if="!noShow && pageName=='templatePage' && useid != createUserId">
					<el-button style="width: 110px;" plain @click="reject">驳回</el-button>
					<el-button style="width: 110px;" type="primary" @click="pass">通过</el-button>
				</div>
				
				<butterfly-vue ref="butterfly" className="flowChartBox" :canvasData="logicData.mockData" key="flowChartBox" />
			</div>
		</div>
		<el-dialog
		  title="驳回理由"
		  :visible.sync="centerDialogVisible"
		  width="600px"
		  @close="textarea=''"
		  center>
		  <el-input
			type="textarea"
			:maxlength="200"
			:autosize="{ minRows: 4, maxRows: 6}"
			show-word-limit
			placeholder="请输入内容"
			v-model="textarea">
		  </el-input>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="sureReject">确 定</el-button>
		  </span>
		</el-dialog>
		<div></div>
	</div>
</template>

<script>
	import {
		decisionTreeDetail,
		decisionTypeList,
		decisionTreeInsertUpdate,
		decisionTreeSubmitApproval,
		cancelApproval,
		decisionTreePublish,
		decisionTreeDelete,
		decisionTreeApproval,
		patientSchemeGetDetail 
	} from './api'; 
	import local from '@/utils/local.js'
	import ButterflyVue from "@/views/decisionPage/flowChart/butterfly-vue.vue";
	import nodeType from "@/views/decisionPage/flowChart/node-type.vue";
	import {
		api_get_disease_type
	} from '@/api/ManagementPlan'

	export default {
		data() {
			return {
				breadList:[{name:'决策设置'},{name:'患者逻辑'}],
				centerDialogVisible:false,
				textarea:"",
				logicData: {
				  leftData: [],
				  mockData: {
				    nodes: [],
				    groups: [],
				    edges: []
				  }
				},
				form: {
					description: "",
					name: "",
					diseaseId: "",
					subDiseaseIds: [],
					subDiseaseNames:"",
					typeId: '',
					typeNames:"",
					diseaseName: "",
					id: "",
				},
				publishStatus:false,
				status:0,
				isEdit: false,
				fold: false,
				formRule: {
					name: [{
						required: true,
						message: '请输入逻辑名称',
						trigger: 'blur'
					}, ],
					// description: [
					// 	{ required: true, message: '请输入描述', trigger: 'blur' },
					// ],
					typeId: [{
						required: true,
						message: '请选择分类',
						trigger: 'change'
					}, ],
					diseaseId: [{
						required: true,
						message: '请选择主适配病种',
						trigger: 'change'
					}, ],
				},
				decisionType: [],
				diseaseListData: [],
				pageName:"",
				useid:"",
				createUserId:"",
				noShow:false,
			}
		},
		created() {
			this.noShow = !!this.$route.query.noShow;
			api_get_disease_type().then((res) => {
				if (res.code == 0) {
					this.diseaseListData = res.data
				}
			})
			this.useid = local.get('userid')
			decisionTypeList({}).then(res => {
				this.decisionType = res.data;
			})
			this.pageName = JSON.parse(localStorage.getItem('decisionTreeObj')).pageName;
			this.getDetail(this.$route.query.id)
		},
		components:{
			ButterflyVue
		},
		methods:{
			pass(){
				decisionTreeApproval({
					decisionTreeId:this.form.id,
					isPass:true,
				}).then(res=>{
					this.$message.success("操作成功");
					setTimeout(()=>{
						this.$router.go(-1);
					},1000)
				})
			},
			sureReject(){
				if(!this.textarea.trim()){
					this.$message.info("请填写驳回理由");
					return;
				}
				decisionTreeApproval({
					decisionTreeId:this.form.id,
					isPass:false,
					remark:this.textarea
				}).then(res=>{
					this.$message.success("驳回成功");
					setTimeout(()=>{
						this.$router.go(-1);
					},1000)
				})
			},
			reject(){
				this.centerDialogVisible = true;
			},
			deleteItem(){
				this.$confirm('是否确认删除当前逻辑模板吗?', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					decisionTreeDelete(this.form.id).then(res=>{
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						setTimeout(()=>{
							this.$router.go(-1);
						},500)
					})
				})
			},
			getDetail(id){
				if(this.pageName == 'patientPage'){
					patientSchemeGetDetail(id).then(res=>{
						this.createUserId = res.data.createUserId;
						if(res.data.publishedTreeJson){
							let obj = JSON.parse(res.data.publishedTreeJson)
							if (obj.nodes&&obj.nodes.length > 0) {
								obj.nodes.map(item => {
									item.render = nodeType
								})
							}
							this.logicData.mockData = {
								nodes: obj.nodes,
								edges: obj.edges
							}
							this.$refs.butterfly.setMinimap();
						}
						
						this.publishStatus = res.data.publishStatus;
						this.status = res.data.status;
						// this.form.id = res.data.id;
						// this.form.description = res.data.description
						// this.form.name = res.data.name;
						// this.form.diseaseId = res.data.diseaseId;
						
						// this.form.subDiseaseNames = res.data.subDiseaseNames;
						// this.form.subDiseaseIds = res.data.subDiseaseIds.split(',');
						// this.form.typeId = res.data.typeId;
						// this.form.typeName = res.data.typeName;
						// this.form.diseaseName = res.data.diseaseName;
						Object.assign(this.form,res.data);
						// this.form.subDiseaseIds = res.data.subDiseaseIds.split(',');
					})
					
					return;
				}
				
				decisionTreeDetail(id).then(res => {
					this.createUserId = res.data.createUserId;
					if(res.data.treeJson){
						let obj = JSON.parse(res.data.treeJson)
						if (obj.nodes&&obj.nodes.length > 0) {
							obj.nodes.map(item => {
								item.render = nodeType
							})
						}
						this.logicData.mockData = {
							nodes: obj.nodes,
							edges: obj.edges
						}
						this.$refs.butterfly.setMinimap();
					}
					
					this.publishStatus = res.data.publishStatus;
					this.status = res.data.status;
					// this.form.id = res.data.id;
					// this.form.description = res.data.description
					// this.form.name = res.data.name;
					// this.form.diseaseId = res.data.diseaseId;
					
					// this.form.subDiseaseNames = res.data.subDiseaseNames;
					// this.form.subDiseaseIds = res.data.subDiseaseIds.split(',');
					// this.form.typeId = res.data.typeId;
					// this.form.typeName = res.data.typeName;
					// this.form.diseaseName = res.data.diseaseName;
					Object.assign(this.form,res.data);
					// this.form.subDiseaseIds = res.data.subDiseaseIds.split(',');
				})
			},
			Approval(){
				if(this.status==2){
					cancelApproval(this.form.id).then(res=>{
						this.$message.success("操作成功");
						this.getDetail(this.form.id)
					})
				}else{
					decisionTreeSubmitApproval({
						id:this.form.id
					}).then(res=>{
						this.$message.success("操作成功");
						this.getDetail(this.form.id)
					})
				}
				
			},
			publishClick(data){
				if(this.publishStatus){
					decisionTreePublish({
						decisionTreeId:this.form.id,
						isPublish:false
					}).then(res=>{
						this.$message.success("操作成功");
						this.getDetail(this.form.id)
					})
				}else{
					decisionTreePublish({
						decisionTreeId:this.form.id,
						isPublish:true
					}).then(res=>{
						this.$message.success("操作成功");
						this.getDetail(this.form.id)
					})
				}
			},
			goMain(){
				this.$router.push({path:'/decisionMain',query:{decisionTreeId:this.form.id}});
			},
			saveDescription(){
				this.$refs['ruleForm'].validate((valid) => {
				  if (valid) {
					  let obj;
					  if(this.form.subDiseaseIds.length){
						  let subArr=[];
						  this.diseaseListData.forEach(item => {
						    this.form.subDiseaseIds.forEach(v => {
						      if (item.id === v) {
						        subArr.push(item.suborderName)
						      }
						    })
						  })
						  obj = {
							  id:this.form.id, 
							  description:this.form.description,
							  name:this.form.name,
							  diseaseId:this.form.diseaseId,
							  diseaseName:this.form.diseaseName,
							  subDiseaseIds:this.form.subDiseaseIds.join(','),
							  subDiseaseNames:subArr.join(','),
							  typeId:this.form.typeId
						  }
						  
					  }else{
						  obj = {
							  id:this.form.id,
							  description:this.form.description,
							  name:this.form.name,
							  diseaseId:this.form.diseaseId,
							  diseaseName:this.form.diseaseName,
							  typeId:this.form.typeId
						  }
					  }
					  decisionTreeInsertUpdate(obj).then(res=>{
						  this.$message.success("操作成功")
						  this.isEdit = false;
						  this.getDetail(this.form.id)
					  })
				  }else{
					  return false
				  }
				})
			},
			diseaseTypeChange(v){
				this.form.diseaseName = '';
				for (var i = 0; i < this.diseaseListData.length; i++) {
					if(v==this.diseaseListData[i].id){
						this.form.diseaseName = this.diseaseListData[i].suborderName;
					}
				}
			},
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-textarea textarea{
		min-height: 120px !important;
	} 
	.bottom-cont-box {
		margin-top: 16px;
		padding-right: 16px;
		display: flex;
		height: calc(100% - 100px);
		.left-box {
			overflow-y:auto;
			width: 393px;
			background: #fff;
			position: relative; 
			margin-left: 16px;
			border-radius: 6px;
			padding: 16px;
			
			// height: 100%;
			.position_btn {
				width: 69px;
				height: 30px;
				line-height: 30px;
				position: absolute;
				right: 0;
				top: 42px;
				color: #fff;
				text-align: center;
				background: #1A7BFC;
				border-radius: 19px 0px 0px 19px;
				cursor: pointer;
			}
	
			h4 {
				margin-top: 8px;
				font-size: 22px;
				margin-bottom: 55px;
				font-weight: 600;
				text-align: center;
				color: rgba(0, 0, 0, 0.85);
			}
	
			.bottom-btn-box {
				margin-top: 30px;
				// text-align: center;
				padding-left: 100px;
				padding-bottom: 200px;
			}
		}
	
		.right-box {
			flex: 1;
			background: #fff;
			margin-left: 16px;
			// height: 970px;
			background: #FFFFFF;
			border-radius: 6px;
			position: relative;
	
			.position_btn {
				position: absolute;
				text-align: center;
				left: 0;
				top: 42px;
				width: 69px;
				height: 30px;
				line-height: 30px;
				color: #FFFFFF;
				background: #1A7BFC;
				border-radius: 0px 15px 15px 0px;
				cursor: pointer;
			}
	
			.right-btn {
				padding: 20px;
				text-align: right;
			}
			.flowChartBox{
				height: calc(100% - 80px);
			}
		}
	}

	// .bottom-tabel{
	// 	background-color: #fff;
	// 	padding: 16px 17px 0;
	// 	// margin: 0 ;
	// }
	// /deep/.el-pagination {
	// 	text-align: right;
	// 	margin-top: 30px;
	// 	margin-right: 30px;
	// 	padding-bottom: 20px;
	// }
	/deep/.el-select {
		width: 100%;
	}
	.flowChartBox{
		height: calc(100% - 150px);
	}
</style>
